import CostHTMLPreviewBaseColumnsStrategy from './CostHTMLPreviewBaseColumnsStrategy'

export default function CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy() {}

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype = new CostHTMLPreviewBaseColumnsStrategy();

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.init = function({
    timeFormat,
    showSpentTime,
    showAverageRates,
    showUserRates,
    showSubtotals,
    showOthers,
}) {
    CostHTMLPreviewBaseColumnsStrategy.prototype.init.call( this, timeFormat, showSpentTime, showAverageRates );
    this.showUserRates = showUserRates;
    this.showSubtotals = showSubtotals;
    this.showOthers = showOthers
    return this;
};

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.addFirstHeaderRowDataCells = function(row) {
    this.addOverallHeaderCells(row)
    let colSpan = 1
    if (this.showSpentTime) colSpan++
    if (this.showUserRates) colSpan++
    if (this.showSubtotals) {
        colSpan++
        if (this.showSpentTime)
            colSpan++
    } else if (!this.showOthers){
        colSpan = colSpan * 2
    }
    this.addCell(row, SystemSettings.userGroupNamingSingular, "userGroup " + (this.showSpentTime ? "darkHeaderCell" : "darkGreenHeaderCell"), colSpan)

    if (this.showOthers) {
        let othersColSpan = 1
        if (this.showSpentTime) othersColSpan++
        if (this.showUserRates) othersColSpan++
        this.addCell(row, this.message("report.common.others"), this.getUserHeaderCellClassName(), othersColSpan, 2)
    }
}

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.addSecondHeaderRowDataCells = function(row) {
    const userCellColSpan = this.showSpentTime && this.showUserRates ? 3 : 2
    if (this.showSubtotals) {
        const rowSpan = this.showSpentTime ? 1 : 2
        const colSpan = this.showSpentTime ? 2 : 1
        this.addCell(row, this.message("report.subtotal"), this.showSpentTime ? "darkHeaderCell" : "darkGreenHeaderCell", colSpan, rowSpan)
    } else if (!this.showOthers) {
        this.addCell(row, this.message("report.user"), this.getUserHeaderCellClassName(), userCellColSpan)
    }
    this.addCell(row, this.message("report.user"), this.getUserHeaderCellClassName(), userCellColSpan)
}

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.addThirdHeaderRowDataCells = function(row) {
    if (this.showSubtotals) {
        if (this.showSpentTime) {
            this.addCell(row, this.message("report.cost.spent"), "spent")
            this.addCell(row, this.message("report.cost.cost"), "cost")
        }
    } else if (!this.showOthers) {
        this.addThirdLevelUserCols(row)
    }

    this.addThirdLevelUserCols(row)

    if (this.showOthers) this.addThirdLevelUserCols(row)
}

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.addThirdLevelUserCols = function( row )
{
    if( this.showSpentTime )
        this.addCell( row, this.message( "report.cost.spent" ), "spent" );
    if( this.showUserRates )
        this.addCell( row, this.message( "report.cost.rate" ), "rate" );
    this.addCell( row, this.message( "report.cost.cost" ), "cost" );
};

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.addUserCols = function( row )
{
    if( this.showSpentTime )
        this.addTimeValueCell( row );
    if( this.showUserRates )
        this.addMoneyValueCell( row );
    this.addCostDataCell( row );
};

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.addDataCells = function(row) {
    this.addOverallDataCells(row)
    if (this.showSubtotals) {
        if (this.showSpentTime) this.addTimeValueCell(row)
        this.showSpentTime ? this.addCostDataCell(row) : this.addMoneyValueCell(row)
    } else if (!this.showOthers) {
        this.addUserCols(row)
    }
    this.addUserCols(row)

    if (this.showOthers) this.addUserCols(row)
}

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.getDataColumnsCount = function() {
    const oneUserColumnWidth = this.showSpentTime && this.showUserRates ? 3 : 2
    let userCols = oneUserColumnWidth
    let count = userCols
    if (this.showSubtotals) {
        count++
        if (this.showSpentTime) count++
    } else if (!this.showOthers) {
        count += userCols
    }

    if (this.showOthers) count += oneUserColumnWidth

    return this.getOverallColumnsCount() + count
}

CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.prototype.getUserHeaderCellClassName = function ()
{
    return this.showSpentTime ? "lightHeaderCell" : "lightGreenHeaderCell";
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewUsersByGroupsThreeLevelsColumnsStrategy.js